"use strict";

var _interopRequireDefault = require("C:/Users/sandy/Desktop/EIOSYS/Admin/Alembic-Grow-Admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _tslib = require("tslib");
var _vuePropertyDecorator = require("vue-property-decorator");
var _BarChart = _interopRequireDefault(require("./components/BarChart.vue"));
var _PieChart = _interopRequireDefault(require("./components/PieChart.vue"));
var _PanelGroup = _interopRequireDefault(require("./components/PanelGroup.vue"));
let default_1 = class extends _vuePropertyDecorator.Vue {
  constructor() {
    super(...arguments);
    this.validity = {};
  }
  created() {}
};
default_1 = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  name: 'DashboardAdmin',
  components: {
    BarChart: _BarChart.default,
    PanelGroup: _PanelGroup.default,
    PieChart: _PieChart.default
  }
})], default_1);
var _default = exports.default = default_1;